<template>
    <div
        id="app"
        :class="{
            'background': $route.name !== 'Home',
            'background-contact': $route.name === 'Contact',
            'app--stores': $route.name === 'Stores',
            'app--about': $route.name === 'About',
            'app--contact': $route.name === 'Contact',
            'app--product': $route.name === 'Products',
            'app--product-alcohol': $route.fullPath.includes('alcohol'),
        }"
    >
        <div id="nav">
            <router-link class="nav__logo" to="/" exact v-html="lang.logo">

            </router-link>

            <div
                v-if="userDevice === 'mobile'"
                @click="toggleMenuModal"
                class="svg-burger-menu"
                :class="{ 'hidden': menuModalVisible }"
            >
                <svg-icon icon="burger-menu"/>
            </div>

            <ul v-else class="nav__links">
                <li
                    class="nav__link"
                    v-for="link in links"
                    :key="link.route"
                >
                    <router-link :to="`/${link.route}`" exact>
                        {{ link.title }}
                    </router-link>
                </li>

                <language-button />
            </ul>
        </div>

        <router-view/>

        <the-footer/>

        <menu-modal v-show="menuModalVisible" @newClick="showValue" />
    </div>
</template>

<script>
import bg from '@/lang/bg'
import en from '@/lang/en'

import LanguageButton from '@/components/LanguageButton'
import SvgIcon from '@/components/SvgIcon'
import MenuModal from '@/components/MenuModal'
import TheFooter from '@/components/TheFooter'

export default {
    name: 'App',
    components: {
        LanguageButton,
        SvgIcon,
        MenuModal,
        TheFooter,
    },
    data() {
        return {
            bigScreen: null,
            language: null,
            menuModalVisible: false,
            userDevice: null,
        }
    },
    computed: {
        lang() {
            return this.language === 'en' ? en : bg
        },
        links() {
            return [
                {
                    title: this.lang.links.home,
                    route: '',
                },
                {
                    title: this.lang.links.stores,
                    route: 'stores',
                },
                {
                    title: this.lang.links.about,
                    route: 'about',
                },
                {
                    title: this.lang.links.contact,
                    route: 'contact',
                },
            ]
        },
    },
    methods: {
        setLanguage() {
            const select = document.getElementById('lang-select')

            this.language = select.value

            select.addEventListener('change', () => {
                this.language = select.value
            })
        },
        toggleMenuModal() {
            this.menuModalVisible = !this.menuModalVisible

            if (this.menuModalVisible) document.body.style.overflow = 'hidden'
            else document.body.style.overflow = 'visible'
        },
        setDevice() {
            const { innerWidth: width, } = window

            /* eslint-disable */
            switch (true) {
                case (width >= 1920) :
                    this.bigScreen = true
                case (width >= 1024):
                    return this.userDevice = 'desktop'
                case (width >= 768):
                    return this.userDevice = 'tablet-portrait'
                default:
                    return this.userDevice = 'mobile'
            }
            /* eslint-enable */
        },
        showValue(value) {
            this.language = value
        },
    },
    mounted() {
        this.setDevice()

        // TODO: Make throttler - maybe 1 call each second
        window.addEventListener('resize', () => this.setDevice())

        this.setLanguage()
    },
}
</script>

<style lang="scss">
* {
    box-sizing: border-box;
}

html, body {
    height: 100%;
    min-height: 100%;
}

body {
    margin: 0;
    padding: 0;
    overflow-x: hidden;
}

a {
    color: white;
    text-decoration: none;

    &:hover {
        color: #57e2e2;
    }
}

h1 {
    margin-top: 56px;
    font-size: 24px;
    font-weight: 700;

    @media (min-width: 768px) {
        margin-top: 150px;
    }
}

button {
    border: none;
    outline: none;
    cursor: pointer;
}

input:focus, textarea:focus {
    outline-color: #343434;
}

#app {
    display: flex;
    flex-direction: column;
    color: #2c3e50;
    font-family: 'Rubik', cursive;
    text-align: center;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}

#nav {
    display: flex;
    position: absolute;
    z-index: 1;
    width: calc(100% - 36px);
    margin: 18px;
    justify-content: space-between;

    @media (min-width: 768px) {
        width: calc(100% - 100px);
        margin: 45px 50px 0;
    }

    @media (min-width: 1024px) {
        width: calc(100% - 146px);
        margin-left: 62px;
    }

    @media (min-width: 1366px) {
        margin: 45px 0 0 130px;
        justify-content: space-between;
    }

    @media (min-width: 1600px) {
        justify-content: space-around;
    }

    @media (min-width: 2000px) {
        justify-content: space-evenly;
    }

    .nav {
        &__links {
            display: flex;
            margin-top: 0;
            padding: 0;
            color: white;
            font-size: 20px;
            list-style-type: none;
            font-weight: 700;
            cursor: pointer;

            &:hover {
                cursor: pointer;
            }

            @media (min-width: 768px) {
                font-size: 18px;
            }

            @media (min-width: 1024px) {
                margin-right: 0;
                font-size: 20px;
            }

            @media (min-width: 1366px) {
                margin-right: 128px;
            }

            .router-link-exact-active {
                border-bottom: 3px solid #57e2e2;
            }
        }

        &__link {
            margin-left: 24px;
        }

        &__logo {
            color: rgb(159, 120, 169);
            font-size: 20px;
            font-weight: 700;
            text-decoration: none;
            text-transform: uppercase;

            &:hover {
                color: #57e2e2 !important;
            }

            @media (min-width: 414px) {
                font-size: 24px;
            }

            @media (min-width: 1024px) {
                font-size: 28px;
            }

            &--split-color {
                color: #a5a2a2;
            }
        }
    }
}

.hidden {
    display: none;
}

.background {
    background-color: #001d27;
}
</style>
